<template>
	<div>
		<div class="mb-6 flex items-center justify-between">
      <h2 class="font-semibold text-lg text-black">Llamadas</h2>
      <button
        @click="showModal = true"
        class="group text-tuin-100 border border-tuin-100 hover:bg-tuin-100 hover:text-white flex items-center justify-center gap-2 sm:px-4 sm:py-2.5 p-2.5 sm:rounded-lg rounded-full transition text-sm font-medium"
      >
        <svg class="only-dest" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.21217 0 4.41566 0.0842856 4.56569 0.234315C4.71571 0.384344 4.8 0.587827 4.8 0.8V3.2H7.2C7.41217 3.2 7.61566 3.28429 7.76569 3.43431C7.91571 3.58434 8 3.78783 8 4C8 4.21217 7.91571 4.41566 7.76569 4.56569C7.61566 4.71571 7.41217 4.8 7.2 4.8H4.8V7.2C4.8 7.41217 4.71571 7.61566 4.56569 7.76569C4.41566 7.91571 4.21217 8 4 8C3.78783 8 3.58434 7.91571 3.43431 7.76569C3.28429 7.61566 3.2 7.41217 3.2 7.2V4.8H0.8C0.587827 4.8 0.384344 4.71571 0.234315 4.56569C0.0842856 4.41566 0 4.21217 0 4C0 3.78783 0.0842856 3.58434 0.234315 3.43431C0.384344 3.28429 0.587827 3.2 0.8 3.2H3.2V0.8C3.2 0.587827 3.28429 0.384344 3.43431 0.234315C3.58434 0.0842856 3.78783 0 4 0V0Z" class="fill-tuin-100 group-hover:fill-white"/>
        </svg>
        <svg class="only-mob fill-tuin-100 stroke-tuin-100 group-hover:fill-white group-hover:stroke-white transition" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 8H1H8Z"/>
          <path d="M8 1V8M8 8V15M8 8H15M8 8H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="only-dest">Agregar Llamada</span>
      </button>
    </div>

    <div
      class="bg-gray-100 p-4 rounded-lg" 
      v-if="(props.calls != null && props.calls.length > 0)"
    >
      <div
        v-for="call in props.calls"
        :key="call.id"
        class="mb-3"
      >
        <div class="flex items-start gap-3">
          <label
            :for="'status-' + call.id"
            class="flex items-start gap-3"
          >
            <div class="flex flex-col">
              <span class="text-sm font-medium text-gray-900">
                {{ call.subject }}
              </span>

              <span class="text-xs font-normal text-gray-500">
                {{ formattedDate(call.call_date) }}
              </span>
              <p class="text-xs font-normal text-gray-500">
                {{ call.detail }}
              </p>
            </div>
          </label>
        </div>
      </div>
    </div>

		<div  
      v-else
      class="flex flex-col items-center justify-center text-center py-8"
    >
      <div class="flex justify-center items-center mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
					<path d="M5.03735 15.9227C3.77335 13.7201 3.16268 11.92 2.79468 10.096C2.25068 7.39738 3.49601 4.76138 5.55868 3.07872C6.43068 2.36805 7.43068 2.61205 7.94668 3.53605L9.11068 5.62538C10.0333 7.28138 10.4947 8.10805 10.404 8.98538C10.312 9.86405 9.68935 10.5787 8.44535 12.008L5.03735 15.9227ZM5.03735 15.9227C7.59601 20.3841 11.6107 24.4027 16.0773 26.9627M16.0773 26.9627C18.2813 28.2267 20.08 28.8374 21.904 29.2054C24.6027 29.7494 27.2387 28.5041 28.92 26.4414C29.632 25.5694 29.388 24.5694 28.464 24.0534L26.3747 22.8894C24.7187 21.9667 23.892 21.5054 23.0147 21.5961C22.136 21.6881 21.4213 22.3107 19.992 23.5547L16.0773 26.9627Z" stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
      </div>
      <p class=" text-base text-gray-900">
        No tienes Llamadas para este Prospecto
      </p>
    </div>
		
    <LeadsCallsModal
      v-if="showModal"
      @close="showModal = false"
      @call-saved="(data) => {
        showModal = false;
        emit('call-saved', data);
      }"
      :leadId="props.leadId"
    />
	</div>
</template>
<script setup>
import { ref } from 'vue';
import LeadsCallsModal from './Modal/LeadsCallsModal.vue';
import { useDateFormat } from '@vueuse/core'

const props = defineProps({
  calls: {
    type: Array,
    default: () => [],
  },
  leadId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['call-saved']);
const formattedDate = (date) => useDateFormat(date, 'DD/MM/YYYY')

let showModal = ref(false);
</script>